import {
  type Query,
  defaultShouldDehydrateQuery,
  hashKey,
} from '@tanstack/react-query';

import { queryKeys } from '@splitfiesta/core';

const FEATURE_FLAGS_HASH = hashKey(queryKeys.featureFlags());
const CLAIM_LINK_SEGMENT = queryKeys.claimLink('')[1];

/**
 * The default keeps successful queries only. The flags keep their last good
 * answer on disk after a failed refetch too: the feed key reads them, and
 * losing them offline would hide a cached feed. A public bill link never
 * goes to disk: a reload must not reopen a link stopped meanwhile.
 */
export const persistDehydrateOptions = {
  shouldDehydrateQuery: (query: Query) =>
    query.queryKey[1] !== CLAIM_LINK_SEGMENT &&
    (defaultShouldDehydrateQuery(query) ||
      (query.state.data !== undefined &&
        query.queryHash === FEATURE_FLAGS_HASH)),
};
